import { useEffect, useRef } from 'react';
import './Stats.css';

const stats = [
  { target: 500, label: 'Brands Grown', suffix: '+' },
  { target: 94, label: ' AI Accuracy', suffix: '%' },
  { target: 5, label: ' Avg. ROI Boost', suffix: '×' },
  { target: 48, label: 'Hr Campaign Launch', suffix: 'hr' },
];

function animCount(el, target) {
  let start = null;
  const dur = 2400;
  const step = ts => {
    if (!start) start = ts;
    const p = Math.min((ts - start) / dur, 1);
    // Cubic ease-out
    const eased = 1 - Math.pow(1 - p, 3);
    el.textContent = Math.floor(eased * target);
    if (p < 1) requestAnimationFrame(step);
    else el.textContent = target;
  };
  requestAnimationFrame(step);
}

export default function Stats() {
  const stripRef = useRef(null);
  const numRefs = useRef([]);

  useEffect(() => {
    let triggered = false;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !triggered) {
          triggered = true;
          numRefs.current.forEach((el, i) => {
            if (el) animCount(el, stats[i].target);
          });
        }
      },
      { threshold: 0.5 }
    );
    if (stripRef.current) obs.observe(stripRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div className="stats-strip reveal-scale" ref={stripRef}>
      {stats.map((s, i) => (
        <div key={s.label} className="stat">
          <span className="stat-num" ref={el => (numRefs.current[i] = el)}>0</span>
          <span className="stat-label">{s.label}</span>
        </div>
      ))}
    </div>
  );
}
